"use strict"

import {observable, action} from "mobx"

import {getFilters} from "../../global/helpers/api"
import {getUserCompanyInfo, getUser, logout} from "../../global/helpers/actions"
import api from "../../global/actions/api"
import ConsentSentDialogStore from "./ConsentSentDialogStore"
import moment from "moment"
import GlobalStore from "../../global/store/GlobalStore"

class RequestStore {
	@observable data = []

	@action getRequests() {
		GlobalStore.loading(true, "Načítam...")

		let req = getFilters(
			isNotEmpty(getUserCompanyInfo().company_id) ? [`company_id=${getUserCompanyInfo().company_id}`] : []
		)

		api
			.getRequests(req)
			.call()
			.then((res) => {
				if (isSafe(res) && isSafe(res.rows)) {
					this.data = res.rows
				} else {
					this.data = []
				}

				GlobalStore.loading(false)
			})
			.catch(() => {
				const user = getUser()
				if (isSafe(user) && user.expires) {
					const now = moment.utc()
					const expires = moment(new Date(user.expires)).utc()
					if (expires.isValid() && expires.isBefore(now, "second")) {
						logout()
					}
				}
				GlobalStore.loading(false)
			})
	}

	@action sendRequest(form, requestId) {
		GlobalStore.loading(true)

		const req = {
			consent_personal_data_processing: true
		}

		api
			.sendRequest(requestId, req)
			.call()
			.then((response) => {
				if (isNotEmpty(response)) {
					GlobalStore.setNotificationMessage("Odoslanie prebehlo úspešne", "", "success")
					this.getRequests()
				}
				ConsentSentDialogStore.close(form)
				GlobalStore.loading(false)
			})
			.catch(() => {
				GlobalStore.loading(false)
			})
	}
}

var singleton = new RequestStore()
export default singleton

